export class AccountInfo {
	constructor (login) {
		this._login = login
	}

	setVisible = visible => {
		if (visible) {
			this._login.accountManagement()
		}
	}
}